"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Strings = require("../core/Strings");

var _MeasureText = require("../utils/MeasureText");

var _UITextArea = _interopRequireDefault(require("./UITextArea"));

var UIMatchTextArea =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIMatchTextArea, _Component);

  function UIMatchTextArea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIMatchTextArea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIMatchTextArea).call(this, props));
    _this.state = {
      matchTextHeight: null
    };
    _this.computeMatchTextHeight = _this.computeMatchTextHeight.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIMatchTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Handle case where initial "value" and "match" props are equal.
      var _this$props = this.props,
          match = _this$props.match,
          onMatchedChange = _this$props.onMatchedChange,
          value = _this$props.value;

      if (value === match) {
        onMatchedChange((0, _SyntheticEvent.default)(value === match));
      }

      this.computeMatchTextHeight();
      window.addEventListener('resize', this.computeMatchTextHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.match !== this.props.match) {
        this.computeMatchTextHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.computeMatchTextHeight);
    }
    /**
     * Measure the match text to determine the height of the <textarea>.
     */

  }, {
    key: "computeMatchTextHeight",
    value: function computeMatchTextHeight() {
      var _this$props2 = this.props,
          inputRef = _this$props2.inputRef,
          match = _this$props2.match;
      var inputEl = inputRef.current;
      if (!inputEl) return;
      var originalInputValue = inputEl.value;
      inputEl.value = match;
      var matchTextHeight = (0, _MeasureText.getTextHeight)(inputEl);
      inputEl.value = originalInputValue;

      if (matchTextHeight !== this.state.matchTextHeight) {
        this.setState({
          matchTextHeight: matchTextHeight
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var _this$props3 = this.props,
          match = _this$props3.match,
          matched = _this$props3.matched,
          onChange = _this$props3.onChange,
          onMatchedChange = _this$props3.onMatchedChange;
      var value = evt.target.value;

      if (!(0, _Strings.inputCouldMatch)(value, match)) {
        return;
      }

      onChange(evt);
      var newMatched = value === match;

      if (newMatched !== matched) {
        onMatchedChange((0, _SyntheticEvent.default)(newMatched));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          inputClassName = _this$props4.inputClassName,
          match = _this$props4.match,
          __matched = _this$props4.matched,
          __onChange = _this$props4.onChange,
          __onMatchedChange = _this$props4.onMatchedChange,
          size = _this$props4.size,
          value = _this$props4.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["className", "inputClassName", "match", "matched", "onChange", "onMatchedChange", "size", "value"]);
      var matchTextHeight = this.state.matchTextHeight;
      var style = {
        height: matchTextHeight
      };
      return _react.default.createElement("div", {
        className: (0, _classNames.default)('private-match-text', className)
      }, _react.default.createElement("label", {
        className: (0, _classNames.default)('form-control private-form__control private-match-text__placeholder', {
          'private-match-text__placeholder--xxl': size === 'xxl'
        }),
        style: style
      }, match), _react.default.createElement(_UITextArea.default, (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('private-match-text__input', inputClassName, {
          'private-match-text__input--xxl': size === 'xxl'
        }),
        "data-match-value": match,
        value: value,
        onChange: this.handleChange,
        resize: false,
        style: style
      })));
    }
  }]);
  return UIMatchTextArea;
}(_react.Component);

UIMatchTextArea.displayName = 'UIMatchTextArea';
UIMatchTextArea.propTypes = (0, _extends2.default)({}, _UITextArea.default.propTypes, {
  inputClassName: _react.PropTypes.string,
  match: _react.PropTypes.string,
  matched: _react.PropTypes.bool,
  onMatchedChange: _react.PropTypes.func.isRequired,
  size: _react.PropTypes.oneOf(['md', 'xxl'])
});
UIMatchTextArea.defaultProps = (0, _extends2.default)({}, _UITextArea.default.defaultProps, {
  matched: false
});

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UIMatchTextArea, ['matched', 'value']));

exports.default = _default;
module.exports = exports.default;